export default __webpack_public_path__ + "static/media/brand.b0bff435.png";